var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"flex","width":"100%","height":"100vh"}},[(_vm.showFooter)?_c('leftPage'):_vm._e(),_c('div',{staticStyle:{"flex":"1"}},[(_vm.showFooter)?_c('topPage'):_vm._e(),_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }